export class TableNpb {

    // table definition
    data: any[] = [];
    cols: any[];    // main table columns

    constructor() {

        this.cols = [
            { field: 'npanxxx', header: 'Block', width: '8.5' },
            { field: 'blkOcn', header: 'Block Owner OCN', width: '7', 'toolTip':'OCN for the block owner from LERG6' },
            { field: 'blkOcnName', header: 'Block Owner OCN Name', width: '10.75' },
            { field: 'codeOcn', header: 'Code Owner OCN', width: '7', 'toolTip':'OCN for the code owner from LERG6' },
            { field: 'codeOcnName', header: 'Code Owner OCN Name', width: '10' },
            { field: 'aTime', header: 'Activation Date/Time (ET)', width: '11', 'toolTip':'Date/time a Number Pool Block became active' },
            { field: 'lrn', header: 'LRN', width: '6', 'toolTip':'LRN for an active Number Pool Block' },
            { field: 'spid', header: 'SPID', width: '4', 'toolTip':'NPAC SPID for the block or code owner' },
            { field: 'spName', header: 'SP Name', width: '7.25' },
            { field: 'altSpid', header: 'Alt SPID', width: '5.25' },
            { field: 'laltSpid', header: 'Last Alt SPID', width: '6.75' },
            { field: 'lata', header: 'LATA', width: '4' },
            { field: 'lataName', header: 'LATA Name', width: '6.25' },
            { field: 'rc', header: 'Rate Center', width: '8' },
            { field: 'region', header: 'Region', width: '5.5' },
            { field: 'state', header: 'State', width: '3' },
        ];

    }

}

